// in src/App.js
import { Admin, Resource, CustomRoutes } from 'react-admin'
import { BrowserRouter, Route } from 'react-router-dom'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import frenchMessages from 'ra-language-french'
import { TicketList, TicketEdit, TicketCreate } from './tickets'
import { TicketArchivedList } from './tickets_archived'
import {
  AG1,
  AG2,
  AG3_refactored,
  AG4,
  AG5,
  AG6,
  AG_Convocation,
} from './ags/ags'
import { AgList1, AgList2, AgList3 } from './ags/ag_list'
import { PvAg } from './ags/pvags'
import { Mec } from './mec'
import {
  InvoicesList1,
  InvoicesList2,
  InvoicesCreate1,
  InvoicesList3,
  InvoicesEdit1,
} from './invoices'
import { PvAgFeuillePresence } from './ags/pvags_feuillepresence'
import { PvAgConvocation } from './ags/pvags_convocation'
import { CoproList } from './copros'
import { CoproNewsList } from './copros_news'

import CoproShow from './copros/CoproShow'
import { CoproFicheList, CoproFicheEdit } from './copros_fiche'
import { CoproFicheExtView } from './ext_coproprietaires/fiche/ext_copros_fiche'

import { ContractsList, ContractEdit, ContractCreate } from './contracts'
import { PrefList, PrefEdit } from './contacts_pref'
import { FrontPluginTickets } from './frontplugin_tickets'
import { ContactsList } from './contacts'
import { CoproSummaryEdit } from './ext_coprosummary'
import { CoproprietaireExtranet } from './ext_coproprietaires/ext_coproprietaires'
import { ProcessList, ProcessCreate, ProcessEdit } from './process'
import {
  RoutingConfigList,
  RoutingConfigCreate,
  RoutingConfigEdit,
} from './routing_config'
import { RoutingList } from './routing_rules'
import { RoutingKeywordsList, RoutingKeywordCreate } from './routing_keywords'
import { RoutingAiKeywordCreate } from './routing_ai_keywords'
import { UsersList, UserEdit, UserCreate } from './users'
import { AgRegistrationShow } from './ags/agregistration'
import { PrestaList, PrestaEdit, PrestaCreate } from './prestas'
import { CoproMondayList } from './copros_monday'
import { TagCreate, TagEdit, TagsList } from './tags'
import { VarsList, VarEdit } from './global_vars'
import { ExtranetAgs, ExtranetAgsHome } from './ags/extranet_ags'
import { PostCreateComponent } from './ext_copro_tickets'
import { ExtCoproTicketCreateDialog } from './ext_coproprietaires/ticket_create_dialog'
import { ExtCoproTicketListDialog } from './ext_coproprietaires/ticket_list_dialog'
import { ExtCoproInvoiceListDialog } from './ext_coproprietaires/invoice_list_dialog'
import {
  TicketListPo,
  TicketListGe,
  TicketEditEP,
  TicketCreateEP,
  TicketShowEP,
} from './entrypoints'
import { myDataProvider } from './dataProvider'
import GroupIcon from '@mui/icons-material/Group'
import ApartmentIcon from '@mui/icons-material/Apartment'
import MyLayout from './layout/layout'
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles'
import './App.css'
import NotFound from './error_pages/NotFound'
import authProvider from './auth/auth_provider'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import MecDialog from './ext_coproprietaires/mec_dialog'
import { LandingPage } from './landing'

import { EditHandler, FileView, ListFileView } from './components/file_upload'
import { ListMonitoringAI } from './components/list_monitoring_ai'

import moment from 'moment'
import { PostalVotingPage } from './ags/postal_voting'
import { RoutesCompliance } from './compliance/routes'
import { RoutesDashboard } from './dashboards/router'
import { ListLetters } from './letters'
import { CreateReleases, EditReleases, ListReleases } from './releases'
import { ConcentTemplatePage } from './ags/concent_template'
import {
  CreateCoprosGeneralNews,
  EditCoprosGeneralNews,
  ListCoprosGeneralNews,
} from './copros/copros_general_news'
import { ExtranetPrestas } from './extranet_prestas'
import ConvocationDigital from './ags/convocation_digital'
import ConvocationPaper from './ags/convocation_paper'
import ExtranetTickets from './pages/ExtranetTickets'
import { AuthProviderExtranet } from './context/AuthProviderExtranet'
import { PersistLoginExtranet } from './ext_coproprietaires/Authentication/components'
import LoginExtranet from './ext_coproprietaires/Authentication'
import RequireAuthExtranet from './components/common/RequireAuthExtranet'
import { RGDD } from './ext_coproprietaires/RGDD/'
import { BudgetOverview } from './ext_coproprietaires/BudgetOverview'
import { BudgetCompliance } from './intranet/BudgetCompliance'
import config from './config'
import { LetterTemplatesEdit } from './intranet/LetterTemplatesEdit'
import { LetterSendingForm } from './intranet/LetterSendingForm'
import { LetterTemplatesList } from './intranet/LetterTemplatesList'
import { LetterSendingResponse } from './intranet/LetterSendingResponse'
import { Home } from './intranet/Home'
import { BankingHistoryExtranet } from './ext_coproprietaires/BankingHistory/'
import { TicketListDraftGeneric } from './tickets_generic'
import RingoverProvider from './context/RingoverProvider'
import { RingoverControl } from './intranet/RingoverControl'
import AccountDisabled from './error_pages/AccountDisabled'
import Unauthorized from './error_pages/Unauthorized'
import { LettersHistory } from './intranet/LettersHistory'
import TagManager from 'react-gtm-module'
import { MassMailList } from './intranet/Massmails'
import { ZendeskPluginHome } from './zendesk/plugin/ZendeskPluginHome'

moment.locale('fr', {
  months:
    'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
      '_'
    ),
  monthsShort:
    'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
  monthsParseExact: true,
  weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
  weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
  weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
  },
  calendar: {
    sameDay: '[Aujourd’hui à] LT',
    nextDay: '[Demain à] LT',
    nextWeek: 'dddd [à] LT',
    lastDay: '[Hier à] LT',
    lastWeek: 'dddd [dernier à] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'dans %s',
    past: 'il y a %s',
    s: 'quelques secondes',
    m: 'une minute',
    mm: '%d minutes',
    h: 'une heure',
    hh: '%d heures',
    d: 'un jour',
    dd: '%d jours',
    M: 'un mois',
    MM: '%d mois',
    y: 'un an',
    yy: '%d ans',
  },
  dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
  ordinal: function (number) {
    return number + (number === 1 ? 'er' : 'e')
  },
  meridiemParse: /PD|MD/,
  isPM: function (input) {
    return input.charAt(0) === 'M'
  },
  // In case the meridiem units are not separated around 12, then implement
  // this function (look at locale/id.js for an example).
  // meridiemHour : function (hour, meridiem) {
  //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
  // },
  meridiem: function (hours) {
    return hours < 12 ? 'PD' : 'MD'
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // Used to determine first week of the year.
  },
})

const messages = () => {
  // We only use French we can add more locales
  const fr = () => {
    const request = new XMLHttpRequest()
    request.open('GET', `${config.API_V1}/unrestricted/translation/fr`, false)
    request.send(null)

    if (request.status === 200) {
      return JSON.parse(request.responseText)
    }

    return {}
  }

  return { ...frenchMessages, ...fr() }
}

const i18nProvider = polyglotI18nProvider(messages, 'fr', {
  allowMissing: true,
})

//Before we used localstorage but since we implemented Front plugin
//which is in an iframe, we can't use localstorage anymore so we use this object
window.context = {}

//I used https://stackoverflow.com/questions/53764626/how-to-change-outline-color-of-material-ui-react-input-component
//for MuiOutlinedInput and MuiFormLabel
const customTheme = createTheme({
  palette: {
    primary: {
      main: '#143A5F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FCCC60',
      contrastText: '#000000',
    },
    background: {
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff7675',
      contrastText: '#ffffff',
    },
    success: {
      main: '#32B796',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ffc107',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Source Sans Pro', sans-pro",
  },
  overrides: {
    MuiFormControl: {
      "[class^='MuiPaper-rounded']": {
        borderRadius: '1rem',
      },
      root: {
        '&.ra-rich-text-input .outlined .ql-editor': {
          backgroundColor: '#f5f5f5',
          boxShadow: 'rgb(0 0 0 / 16%) 0px 1px 4px',
          padding: '12px',
          fontFamily: 'serif',
        },
        '&.ra-rich-text-input .ql-editor::before': {
          backgroundColor: 'transparent',
        },
        '&.ra-rich-text-input .ql-toolbar.ql-snow': {
          backgroundColor: '#f5f5f5',
          padding: '12px',
          marginBottom: '16px',
          boxShadow: 'rgb(0 0 0 / 16%) 0px 1px 4px',
        },
      },
    },
    MuiTextField: {
      root: {
        minWidth: '250px',
      },
    },
    MuiInputBase: {
      root: {
        minWidth: '250px',
      },
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: 'black',
        },
      },
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: 'black',
        },
      },
    },
    RaFileInputPreview: {
      removeButton: {
        display: 'None',
      },
    },
    MuiRadio: {
      colorPrimary: {
        color: 'black',
        '&$checked': {
          color: 'black',
        },
      },
    },
    MuiAppBar: {
      colorSecondary: {
        printColorAdjust: 'exact', //so that we see logo in pvag
      },
    },
    MuiStepIcon: {
      root: {
        color: 'lightgrey',
        '&$completed': {
          color: 'black',
        },
        '&$active': {
          color: 'black',
        },
      },
      text: {
        fill: 'white',
      },
    },
  },
})

export const generateIconUrl = (iconName) =>
  `${config.PUBLIC_URL}/img/icons/icon-${iconName}-color.svg`

const tagManagerArgs = {
  gtmId: config.REACT_APP_GMT_CODE,
  dataLayerName: 'dataLayer',
}

TagManager.initialize(tagManagerArgs)
const App = () => (
  <MuiThemeProvider theme={customTheme}>
    <BrowserRouter>
      <AuthProviderExtranet>
        <RingoverProvider>
          <RingoverControl />
          <Admin
            theme={customTheme}
            dataProvider={myDataProvider}
            layout={MyLayout}
            authProvider={authProvider}
            i18nProvider={i18nProvider}
            catchAll={NotFound}
            loginPage={false}
            logoutButton={false}
          >
            <CustomRoutes>
              <Route element={<PersistLoginExtranet />}>
                <Route element={<RequireAuthExtranet />}>
                  <Route
                    path="/ext_coproprietaires"
                    element={<CoproprietaireExtranet />}
                  />
                </Route>
              </Route>
              <Route element={<LoginExtranet />} path="/ext_login" />
            </CustomRoutes>
            <CustomRoutes>
              <Route path="/landing" element={<LandingPage />} />
            </CustomRoutes>
            <CustomRoutes noLayout>
              <Route
                path="/ags/:ag_id/vpc/:coowner_id"
                element={<PostalVotingPage />}
              />
              <Route
                path="/concent_template"
                element={<ConcentTemplatePage />}
              />
            </CustomRoutes>
            <Resource
              name="home"
              list={Home}
              icon={generateIconUrl('home')}
              options={{
                label: 'Accueil',
              }}
            />
            <Resource
              name="tickets_processowner"
              list={TicketListPo}
              edit={TicketEditEP}
              show={TicketShowEP}
              create={TicketCreateEP}
              icon={generateIconUrl('paint')}
              options={{
                label: 'Espace PO',
              }}
            />
            <Resource
              name="tickets_gestionnaire"
              list={TicketListGe}
              edit={TicketEditEP}
              show={TicketShowEP}
              create={TicketCreateEP}
              icon={generateIconUrl('paint')}
              options={{
                label: 'Espace CM',
              }}
            />
            <Resource
              name="tickets"
              list={TicketList}
              edit={TicketEdit}
              // show={TicketShow}
              create={TicketCreate}
              options={{
                label: 'En cours & archivés',
                subMenu: { name: 'tickets', icon: generateIconUrl('tickets') },
              }}
            />
            <Resource name="tickets/processes" />
            <Resource name="tickets/states" />
            <Resource
              list={TicketListDraftGeneric}
              name="tickets_drafts"
              options={{
                label: 'Pré-tickets',
                subMenu: { name: 'tickets', icon: generateIconUrl('tickets') },
              }}
            />
            <Resource name="mec" show={Mec} />
            <Resource name="ext_tickets" edit={ExtranetTickets} />
            <Resource name="ext_prestas/:ticket_token" list={ExtranetPrestas} />
            <Resource name="ext_tickets_self" />
            <Resource name="ext_ticketsparent" />
            <Resource
              name="invoices1"
              list={InvoicesList1}
              create={InvoicesCreate1}
              edit={InvoicesEdit1}
              options={{
                label: 'Factures',
                subMenu: {
                  name: 'accounting',
                  icon: generateIconUrl('money'),
                },
              }}
            />
            <Resource name="invoices2" list={InvoicesList2} />
            <Resource name="invoices3" list={InvoicesList3} />
            <Resource name="invoices2/copromatic_providers" />
            <Resource name="invoices2/accounts" />
            <Resource name="invoices2/copromatic_accounts" />
            <Resource name="invoices2/repartitions" />
            <Resource name="invoices2/exercises" />
            <Resource name="pvagsfeuillepresence" show={PvAgFeuillePresence} />
            <Resource name="pvagsconvocation" show={PvAgConvocation} />
            <Resource
              name="ags/:ag_id/coowners/:coowner_id/convocation/digital.pdf"
              list={ConvocationDigital}
            />
            <Resource
              name="ags/:ag_id/coowners/:coowner_id/convocation/paper.pdf"
              list={ConvocationPaper}
            />
            <Resource
              name="ags/:ag_id/coowners/:coowner_id/convocation/paper-generic.pdf"
              list={(props) => <ConvocationPaper {...props} generic={true} />}
            />
            <Resource
              name="process"
              list={ProcessList}
              edit={ProcessEdit}
              create={ProcessCreate}
              options={{
                label: 'Process',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource name="process_published" />
            <Resource name="ext_process" />
            <Resource name="ext_contactpref" />
            <Resource
              name="tags"
              list={TagsList}
              create={TagCreate}
              edit={TagEdit}
              options={{
                label: 'Tags',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="releases"
              list={ListReleases}
              create={CreateReleases}
              edit={EditReleases}
              options={{
                label: 'Releases',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="ai_monitoring"
              list={ListMonitoringAI}
              options={{
                label: 'resources.ai_monitoring.name',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="report_error"
              options={{
                path: `${config.WEBSITE_URL}/contact-it`,
                label: 'Rapportez une erreur',
                subMenu: {
                  name: 'settings',
                },
              }}
            />
            <Resource name="ext_coprosummary" edit={CoproSummaryEdit} />
            <Resource name="ext_mec_tickets" list={MecDialog} />
            <Resource name="ext_mec" />
            <Resource
              name="ext_copro_tickets"
              create={ExtCoproTicketCreateDialog}
              edit={PostCreateComponent}
              list={ExtCoproTicketListDialog}
            />
            <Resource name="ext_ags_dialog" />
            <Resource name="ext_ags_comments" />
            <Resource
              name="ext_copro_invoices"
              list={ExtCoproInvoiceListDialog}
            />
            <Resource name="RGDD" list={RGDD} />
            <CustomRoutes>
              <Route
                path="/banking-history"
                element={<BankingHistoryExtranet />}
              />
            </CustomRoutes>
            <Resource name="BudgetOverview" list={BudgetOverview} />

            <Resource name="frontplugin_tickets" create={FrontPluginTickets} />
            {/* <Resource name="ext_coproprietaires" list={CoproprietaireExtranet} /> */}
            <Resource name="states" />
            <Resource name="ext_prestas" />
            <Resource name="front_tags" />
            <Resource name="tickets_comments" />
            <Resource name="ticket_fields" />
            <Resource name="ticket_fieldsnorole" />
            <Resource name="ticket_fieldscontact" />
            <Resource name="ticket_field_types" />
            <Resource name="state_transitions" />
            <Resource name="roles" />
            <Resource
              name="massmails"
              list={MassMailList}
              options={{
                label: 'Mailing',
                subMenu: {
                  name: 'customers',
                  icon: generateIconUrl('run'),
                },
              }}
            />
            <Resource
              name="ext_ags2"
              list={ExtranetAgsHome}
              edit={ExtranetAgs}
            />
            <Resource name="ext_ags2a" />
            <Resource name="ag" list={ExtranetAgsHome} edit={ExtranetAgs} />
            <Resource
              name="copros"
              list={CoproList}
              show={CoproShow}
              options={{
                label: 'Copropriétés et PAC',
                subMenu: { name: 'copros', icon: generateIconUrl('door') },
              }}
            />
            <Resource
              name="copros_general_news"
              list={CoproNewsList}
              create={CreateCoprosGeneralNews}
              edit={EditCoprosGeneralNews}
              options={{
                label: 'News',
                subMenu: { name: 'copros' },
              }}
            />
            {/*<Resource
            name="copros_analytics1"
            list={CoprosAnalyticsList1}
            show={CoprosAnalyticsShow}
            options={{
              label: "Copro analytics",
              subMenu: {
                name: "analytics",
                icon: generateIconUrl("kpisbar-chart"),
              },
            }}
          />
          <Resource
            name="copros_analytics2"
            list={CoprosAnalyticsList2}
            show={CoprosAnalyticsShow}
          />*/}
            <Resource
              name="data_kpis"
              options={{
                label: 'Data KPIs',
                path: 'https://metabase.hello-syndic.fr/public/dashboard/d9887aaa-b65a-4fba-a3a1-915031845f55',
                subMenu: {
                  name: 'analytics',
                },
              }}
            />
            <Resource
              name="global_vars"
              list={VarsList}
              edit={VarEdit}
              options={{
                label: 'Variables globales',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="copros_fiche"
              list={CoproFicheList}
              edit={CoproFicheEdit}
              options={{
                label: 'Fiches immeubles',
                subMenu: { name: 'copros', icon: generateIconUrl('door') },
              }}
            />
            <Resource name="ext_copros_fiche" edit={CoproFicheExtView} />
            <Resource
              name="contracts"
              list={ContractsList}
              edit={ContractEdit}
              create={ContractCreate}
              options={{
                label: 'Contrats',
                subMenu: { name: 'copros', icon: generateIconUrl('door') },
              }}
            />
            <Resource
              name="ags1a"
              list={AgList1}
              edit={AG1}
              options={{
                label: 'Assemblées générales',
                subMenu: { name: 'copros', icon: generateIconUrl('door') },
              }}
            />
            <Resource name="ags1c" list={AgList3} edit={AG1} />
            <Resource
              name="ags1b"
              list={AgList2}
              edit={AG1}
              icon={GroupIcon}
              options={{ label: 'AG' }}
            />
            <Resource name="ags2" edit={AG2} />
            <Resource name="ags3" edit={AG3_refactored} />
            <Resource name="ags_convocations" edit={AG_Convocation} />
            <Resource name="ags4" edit={AG4} />
            <Resource name="ags5" edit={AG5} />
            <Resource name="ags6" edit={AG6} />
            <Resource name="pvags" show={PvAg} />
            <Resource
              name="copros_monday"
              list={CoproMondayList}
              icon={ApartmentIcon}
              options={{ label: 'Copros Monday' }}
            />
            <Resource name="copros_mondayfiltered" />
            <Resource
              name="prestas"
              list={PrestaList}
              edit={PrestaEdit}
              create={PrestaCreate}
              options={{
                label: 'Prestataires',
                subMenu: { name: 'tickets', icon: generateIconUrl('tickets') },
              }}
            />
            <Resource name="ext_copros" />
            <Resource name="tickets_activity" />
            <Resource name="agregistrations" show={AgRegistrationShow} />
            <Resource name="ext_agregistrations" />
            <Resource
              name="users"
              list={UsersList}
              edit={UserEdit}
              create={UserCreate}
              options={{
                label: 'Utilisateurs',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource name="ext_users" />
            <Resource name="users_copros" />
            <Resource name="role_instances" />
            <Resource name="ext_prestas" />
            <Resource name="resolutions" />
            <Resource name="coproprietaires_frommonday" />
            <Resource name="copros_text" />
            <Resource name="contracts_frommonday" />
            <Resource name="ext_coproprietaires" />
            <Resource name="ext_copros_monday" />
            <Resource name="votes" />
            <Resource name="ag_votes" />
            <Resource name="ext_votes" />
            <Resource name="ext_prevotes" />
            <Resource name="exercices" />
            <Resource name="signrequests" />
            <Resource name="account_disabled" list={AccountDisabled} />
            <Resource name="unauthorized" list={Unauthorized} />
            <Resource
              name="routing_config"
              list={RoutingConfigList}
              create={RoutingConfigCreate}
              edit={RoutingConfigEdit}
              options={{
                label: 'Routing config',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="routing_rules"
              list={RoutingList}
              options={{
                label: 'Routing rules',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="routing_keywords"
              list={RoutingKeywordsList}
              create={RoutingKeywordCreate}
              options={{
                label: 'Routing Keywords',
                subMenu: { name: 'settings', icon: generateIconUrl('power') },
              }}
            />
            <Resource
              name="routing_ai_keywords"
              list={RoutingAiKeywordCreate}
              options={{
                label: 'Routing AI Keywords',
                subMenu: {
                  name: 'settings',
                  icon: generateIconUrl('power'),
                },
              }}
            />
            <Resource
              name="contacts"
              list={ContactsList}
              options={{
                label: 'Contacts',
                subMenu: {
                  name: 'customers',
                  icon: generateIconUrl('run'),
                },
              }}
            />
            <Resource
              name="coproprietaires"
              list={PrefList}
              edit={PrefEdit}
              options={{
                label: 'Préférences de contact',
                subMenu: {
                  name: 'customers',
                  icon: generateIconUrl('run'),
                },
              }}
            />
            {/* @todo: remove faq and help data from db */}

            {/* -------- Letter sending (paper & electronic) -------- */}

            <Resource
              name="send-letter"
              list={LetterSendingForm}
              options={{
                label: 'Envoi de courriers',
                subMenu: { name: 'mail', icon: generateIconUrl('mail') },
              }}
            />

            <CustomRoutes>
              <Route
                path="/send-letter/success/:is_success"
                element={<LetterSendingResponse />}
              />
            </CustomRoutes>

            <Resource
              name="letters_followup"
              options={{
                label: 'Suivi de courrier',
                subMenu: { name: 'mail', icon: generateIconUrl('mail') },
              }}
            />

            <CustomRoutes>
              <Route path="/letters_followup" element={<LettersHistory />} />
            </CustomRoutes>

            <Resource
              name="letters"
              list={ListLetters}
              icon={generateIconUrl('mail-cost')}
              options={{
                label: 'Facturation courrier',
                subMenu: { name: 'mail', icon: generateIconUrl('mail') },
              }}
            />

            {/* -------- Letter Template listing, creation, edition -------- */}

            <CustomRoutes>
              <Route
                path="/letters_templates/:template_type"
                element={<LetterTemplatesList />}
              />
              <Route
                path="/letters_templates/create"
                element={<LetterTemplatesEdit />}
              />
              <Route
                path="/letters_templates/edit/:template_id"
                element={<LetterTemplatesEdit isEdit />}
              />
            </CustomRoutes>

            {/* ---------------------------------------- */}

            <CustomRoutes>
              <Route
                path="/zendesk_plugin_tickets"
                element={<ZendeskPluginHome />}
              />
            </CustomRoutes>

            <Resource
              name="co_owner_balances"
              options={{
                label: 'Gestion des dettes',
                path: `${config.WEBSITE_URL}/co_owner_balances`,
                subMenu: {
                  name: 'accounting',
                },
              }}
            />
            <Resource
              name="co_owner_balances_properties"
              icon={MonetizationOnIcon}
              options={{
                label: 'Dette par copro',
                path: `${config.WEBSITE_URL}/co_owner_balances/properties`,
                subMenu: {
                  name: 'accounting',
                },
              }}
            />
            <Resource
              name="sepa_1"
              options={{
                path: config.SEPA_ORDERS_URL,
                label: 'Mandats SEPA',
                subMenu: { name: 'accounting' },
              }}
            />
            <Resource
              name="sepa_2"
              options={{
                path: `${config.SEPA_ORDERS_URL}/new`,
                label: 'Envois Mandats SEPA',
                subMenu: { name: 'accounting' },
              }}
            />
            <Resource
              name="budget_compliance"
              list={BudgetCompliance}
              options={{
                label: 'Budgets',
                subMenu: { name: 'accounting' },
              }}
            />
            <Resource
              name="transferable_users"
              options={{
                label: 'Welcome',
                path: `${config.WEBSITE_URL}/transferable_users`,
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="incoming_calls"
              options={{
                label: 'Appels entrants',
                path: `${config.WEBSITE_URL}/calls`,
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="new_quotation"
              options={{
                label: 'Devis et contrats',
                path: `${config.WEBSITE_URL}/quotations/new`,
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="transferts_status"
              options={{
                label: 'Suivi onboarding',
                path: `${config.WEBSITE_URL}/transferts/status`,
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="new_caretaker_contract"
              options={{
                label: 'CDD gardien',
                path: 'https://Hello-Syndic:1enIA5dFSN4InHkr@hello-syndic.monday.com/boards/529729007',
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="hr_docs_to_sign"
              options={{
                label: 'Docs à signer RH',
                path: 'https://Hello-Syndic:1enIA5dFSN4InHkr@hello-syndic.monday.com/boards/578882104',
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="divers_docs_to_sign"
              options={{
                label: 'Docs à signer divers',
                path: 'https://Hello-Syndic:1enIA5dFSN4InHkr@hello-syndic.monday.com/boards/634806240',
                subMenu: { name: 'tooling', icon: generateIconUrl('tools') },
              }}
            />
            <Resource
              name="file_with_context"
              list={ListFileView}
              create={FileView}
              edit={EditHandler}
              icon={generateIconUrl('documents')}
              // @todo: improve the translations in order to do not override the default behaivour.
              options={{
                label: 'resources.file_with_context.name',
              }}
            />
            {RoutesDashboard(generateIconUrl)}
            {RoutesCompliance(generateIconUrl)}
          </Admin>
        </RingoverProvider>
      </AuthProviderExtranet>
    </BrowserRouter>
  </MuiThemeProvider>
)

export default App
